import React, { useState } from "react";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  CourseTopLevelCA,
  CourseTopLevel,
} from "../../../components/AdminComponents/MenuItems";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import { Pagination, Popconfirm, Switch, Table, Tag, message } from "antd";
import {
  capitalizeWords,
  formatDateWithSuffix,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import useCommonListing from "../../../components/AdminComponents/customHooks/useCommonListing";
import { useSelector } from "react-redux";
import EditableImage from "../../../components/icons/EditIcon";
import { FolderOpenTwoTone, SwapOutlined } from "@ant-design/icons";
import axiosInstance from "../../../api/Axios";
import { accessImpersontate } from "../../../config";
const BundleListingCA = () => {
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  const userInfo = useSelector((state) => state.user);
  const ImpersonateAccess = !accessImpersontate(
    userInfo?.data?.impersonate_acc
  );
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    handleSwitchChange,
  } = useCommonListing({
    userInfo,
    passSize: 15,
    passPage: 1,
    passURL: `/learn/bundlelist/?organization=${userInfo?.data?.organization?.id}`,
    loadAgain: loadAgain,
  });
  const [messageApi, contextHolder] = message.useMessage();
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const tagColors = [
    "magenta",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];
  const history = useNavigate();
  const handleRowClick = (record) => {
    if (active) {
      history(
        isCAAdmin
          ? `/ca-admin/trainery-learn/bundles/edit/${record}`
          : `/trainery-learn/bundles/edit/${record}`
      );
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Bundle has been ${props}.`,
      duration: 5,
    });
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Bundle has not been ${props}.`,
      duration: 5,
    });
  };
  const handleDelete = async (record, status) => {
    const updatedValues = {
      status,
    };
    try {
      await axiosInstance.put(`learn/bundle/${record.id}/`, updatedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      LoadAPI();
      CreateSuccessfull("Archived");
    } catch (err) {
      //console.log(err);
      CreateFailed("Archived");
    }
  };
  const columns = [
    {
      title: "Bundle ID",
      dataIndex: "bundle_id",
      key: "bundle_id",
      width: 130,
    },
    {
      title: "Bundle Name",
      dataIndex: "name",
      key: "bundleName",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 250,
    },
    {
      title: capitalizeWords("Users"),
      dataIndex: "user_count",
      key: "user_count",
      width: 80,
      editable: true,
      align: "center",
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          {text && text !== 0 ? (
            <Tag
              color="blue"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                fontWeight: "600",
                padding: 0,
              }}
            >
              {text}
            </Tag>
          ) : null}
        </div>
      ),
    },
    {
      title: capitalizeWords("Courses"),
      dataIndex: "course_count",
      key: "course_count",
      width: 80,
      editable: true,
      align: "center",
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          {text && text !== 0 ? (
            <Tag
              color="blue"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                fontWeight: "600",
                padding: 0,
              }}
            >
              {text}
            </Tag>
          ) : null}
        </div>
      ),
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      width: 300,
      render: (tags) => (
        <>
          {Array.isArray(tags) &&
            tags.map((tag, index) => (
              <Tag color={tagColors[index % tagColors.length]} key={tag}>
                {tag}
              </Tag>
            ))}
        </>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: formatDateWithSuffix,
      width: 120,
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
      width: 120,
    },
    // {
    //   title: "Created Date",
    //   dataIndex: "createdDate",
    //   key: "createdDate",
    //   render: formatDateWithSuffix,
    // },
    {
      title: "Deactivation",
      dataIndex: "deactivate_on",
      key: "deactivate_on",
      render: formatDateWithSuffix,
      width: 120,
    },
    // {
    //   title: "Recurring Reset",
    //   dataIndex: "recurringReset",
    //   key: "recurringReset",
    //   width: 120,
    //   render: (val) => (val ? "Yes" : "No"),
    // },
    {
      title: capitalizeWords("actions"),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      width: 120,
      fixed: "right",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {active && (
            <EditableImage
              handleRowClick={handleRowClick}
              recordId={record.id}
            />
          )}
          {ImpersonateAccess && (
            <Popconfirm
              title={active ? "Archive Bundle" : "Unarchive Bundle"}
              description=" "
              onConfirm={() => handleDelete(record, !active)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
              placement="leftTop"
            >
              {active ? (
                <FolderOpenTwoTone
                  style={{
                    cursor: "pointer",
                    fontSize: "1.9rem",
                    marginLeft: "0.7rem",
                  }}
                  // onClick={() => {
                  //   handleDelete(record);
                  // }}
                  title="Archive"
                  twoToneColor="#eb2f96"
                />
              ) : (
                <SwapOutlined
                  style={{
                    cursor: "pointer",
                    fontSize: "1.8rem",
                    marginLeft: "0.9rem",
                  }}
                  // onClick={() => {
                  //   handleDelete(record);
                  // }}
                  title="Unarchive"
                />
              )}
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];

  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      <CommonTopDetails
        title={active ? "Bundles Summary" : "Inactive Bundles"}
        titleSuffix={`${itemsLength || 0} bundle(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        // marginPass="15px"
        showAddButton={ImpersonateAccess}
        filterAction={true}
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: isCAAdmin
            ? "/ca-admin/trainery-learn/bundles/add"
            : "/trainery-learn/courses/add",
        }}
        filterUrl={false}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: () => {},
        }}
        resetButtonProps={{
          modalProps: () => {},
        }}
        customContent={
          <>
            <Switch
              style={{
                backgroundColor: active ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={active}
              disabled={loading}
              onChange={handleSwitchChange}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
            />
          </>
        }
      />
      <div
        className="table-wrapper"
        style={{ overflowX: "auto", overflowY: "auto" }}
      >
        <Table
          columns={columns}
          dataSource={data}
          size="small"
          bordered
          rowKey="id"
          className="table-container"
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(23)}px`,
          }}
          onRow={(record) => ({
            onClick: (event) => {
              if (
                event.target.closest(".ant-table-cell[data-index='actions']")
              ) {
                return;
              }

              handleRowClick(record.id);
            },
          })}
          style={{ marginInline: "1rem" }}
          pagination={false}
          loading={loading}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["10", "15", "30", "50", "100"]}
          showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </WrapperComponent>
  );
};

export default BundleListingCA;
